import React from 'react'

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core'
import { Controller, useForm } from 'react-hook-form'

import * as service from 'service'
import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'
import useStyles from './styles'

const DialogNewCommitteeRole = ({ open, setOpen, onEvent }) => {
  const classes = useStyles()
  const snackbar = useSnackbar()
  const { handleSubmit, control, errors } = useForm({
    defaultValues: { name: '' },
  })

  const onSubmit = async (data) => {
    try {
      await service.dponet.committeeRoles.create({
        committeeRole: data,
      })

      snackbar.open({
        message: 'Cargo de comitê criado com sucesso',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error, false) ||
          error?.error?.message,
        variant: 'error',
      })
    } finally {
      setOpen(false)
      onEvent()
    }
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle>
          <Box>
            <Typography variant="h5">Novo comitê</Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers className={classes.dialogContent}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" style={{ marginBottom: '4px' }}>
                Nome do Cargo
              </Typography>
              <Controller
                control={control}
                name="name"
                mode="onChange"
                as={
                  <TextField
                    label="Digite o nome do cargo"
                    type="text"
                    color="primary"
                    variant="outlined"
                    error={!!errors?.committeeRole}
                    helperText={errors?.committeeRole?.message}
                    fullWidth
                  />
                }
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions p={2} className={classes.buttonBox}>
          <Box pl={2} pr={1}>
            <Button type="button" variant="text" onClick={() => setOpen(false)}>
              Cancelar
            </Button>
          </Box>
          <Button variant="contained" type="submit" color="primary">
            Cadastrar
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default DialogNewCommitteeRole
